export default "__VITE_ASSET__BBkdhkA$__"